import { render } from "./salary-filter.vue?vue&type=template&id=374e52cc"
import script from "./salary-filter.vue?vue&type=script&lang=js"
export * from "./salary-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__